import {
    AnnotationType,
    InteractionType,
    IQuestion,
    isCustomizableSection,
    Perspective,
    QuestionCategories,
} from "@sp-crm/core";
import { InputFormBlock } from "components/app/input-form-block";
import { Radio, RadioOption } from "components/shared/radio";
import * as React from "react";

const annotationOptionsForNarySingle: RadioOption[] = [
    { key: "none", text: "Disabled" },
    { key: "single", text: "Enabled" },
];

const annotationOptionsForNaryMultiple: RadioOption[] = [
    { key: "none", text: "Disabled" },
    {
        key: "single",
        text: "Single notes box after the multiple choice group",
        helpText: "Show single notes field if any options are checked.",
    },
    {
        key: "perAnswer",
        text: "Inline notes field per checked option",
        helpText: "Show a notes field for each option that is checked.",
    },
];

interface Props {
    question: IQuestion;
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- generic constraint
    updateQuestion: <T extends {}>(
        cb: (q: IQuestion, val: T) => void,
    ) => (val: T) => void;
}
export const EditAnnotations: React.FunctionComponent<Props> = props => {
    const annotationLabel = "Show additional notes field when options are checked";
    const showClientAnnotation =
        props.question.legacyClientInteraction !== InteractionType.none &&
        isCustomizableSection(
            Perspective.Client,
            props.question.category as QuestionCategories,
        );
    const showCommunityAnnotation =
        props.question.legacyCommunityInteraction !== InteractionType.none &&
        isCustomizableSection(
            Perspective.Community,
            props.question.category as QuestionCategories,
        );

    return (
        <div className="flex gap-4">
            {showClientAnnotation && (
                <InputFormBlock additionalClassName="flex-1">
                    <h2 className="text-lg font-medium twoverride">Client</h2>
                    <Radio
                        options={
                            props.question.legacyClientInteraction ===
                            InteractionType.multiple
                                ? annotationOptionsForNaryMultiple
                                : annotationOptionsForNarySingle
                        }
                        value={AnnotationType[props.question.legacyClientAnnotation]}
                        label={annotationLabel}
                        onChange={props.updateQuestion((q, v) => {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
                            const annotationType = AnnotationType[v as any] as any;
                            const enabled = annotationType !== AnnotationType.none;
                            q.legacyClientAnnotation = annotationType;
                            q.prompts.forEach(p => (p.legacyClientAnnotation = enabled));
                        })}
                    />
                </InputFormBlock>
            )}
            {showCommunityAnnotation && (
                <InputFormBlock additionalClassName="flex-1">
                    <h2 className="text-lg font-medium twoverride">Community</h2>
                    <Radio
                        options={
                            props.question.legacyCommunityInteraction ===
                            InteractionType.multiple
                                ? annotationOptionsForNaryMultiple
                                : annotationOptionsForNarySingle
                        }
                        value={AnnotationType[props.question.legacyCommunityAnnotation]}
                        label={annotationLabel}
                        onChange={props.updateQuestion((q, v) => {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
                            const annotationType = AnnotationType[v as any] as any;
                            const enabled = annotationType !== AnnotationType.none;
                            q.legacyCommunityAnnotation = annotationType;
                            q.prompts.forEach(
                                p => (p.legacyCommunityAnnotation = enabled),
                            );
                        })}
                    />
                </InputFormBlock>
            )}
            <div className="flex-1"></div>
        </div>
    );
};
